export default {"src":"/_next/static/media/kvFavicon.0661e019.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};